<template>
    <div class="championship-tab">
        <div v-if="(!regularGames || regularGames.length === 0) && (!playoffGames || playoffGames.length === 0)"
            class="no-games">
            <div class="no-games-icon">🏐</div>
            <h3>Матчи чемпионата не найдены</h3>
            <p>Для выбранного сезона матчи чемпионата еще не добавлены</p>
        </div>

        <div v-else class="championship-content">
            <!-- Таблица результатов регулярного сезона -->
            <div v-if="regularGames && regularGames.length > 0" class="regular-season">
                <results-table :teams="teams" :games="regularGames" :max-matches-per-pair="maxMatchesPerPair" :position-offset="positionOffset" />
            </div>

            <!-- Плей-офф матчи -->
            <championship-playoff v-if="playoffGames && playoffGames.length > 0" :playoff-games="playoffGames" />
        </div>
    </div>
</template>

<script setup>
import ResultsTable from '@/components/features/calendar/ResultsTable.vue';
import ChampionshipPlayoff from '@/components/features/results/ChampionshipPlayoff.vue';

const props = defineProps({
    teams: {
        type: Array,
        required: true,
        default: () => []
    },
    regularGames: {
        type: Array,
        default: () => []
    },
    playoffGames: {
        type: Array,
        default: () => []
    }
    ,
    // Пробрасываем максимальное число матчей на пару (по умолчанию 2)
    maxMatchesPerPair: {
        type: Number,
        default: 2
    },
    // Сдвиг позиции (например, для 5-9 нужно +4)
    positionOffset: {
        type: Number,
        default: 0
    }
});
</script>
